import dayjs from 'dayjs'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import {
  DEFAULT_LANGUAGE,
  Language,
  supportedLangs,
} from '~common/constants.ts'

import en from './locales/en'
import nl from './locales/nl'

const resources = {
  [Language.en]: {
    translation: en,
  },
  [Language.nl]: {
    translation: nl,
  },
}

const initialLng =
  navigator?.language && supportedLangs.includes(navigator.language as Language)
    ? navigator.language
    : DEFAULT_LANGUAGE

document.documentElement.lang = initialLng

i18n.on('languageChanged', (lng) => {
  dayjs.locale(lng.toLowerCase())
  document.documentElement.lang = lng
})

i18n.use(initReactI18next).init({
  debug: true,
  defaultNS: 'translation',
  fallbackLng: DEFAULT_LANGUAGE,
  lng: initialLng,
  load: 'currentOnly',
  ns: 'translation',
  resources,
  supportedLngs: supportedLangs,
})

export default i18n
